import React from 'react'
import { Redirect } from 'react-router-dom'
import {
  Segment,
  Table,
  Grid,
  Header,
  Icon,
  Button,
  Message,
  Label,
  Modal,
  TextArea,
  Form,
  Menu,
  Popup,
  Loader
} from 'semantic-ui-react'
import { NavLink } from 'react-router-dom'

import find from 'lodash/find'
import groupBy from 'lodash/groupBy'
import orderBy from 'lodash/orderBy'

import './ClassRemarks.css'
import ClassRemarksApproval from './ClassRemarksApproval'

const _ = { find, groupBy, orderBy }

const ClassRemarksPV = (props) => {
  if (props.auth) {
    const {
      column, direction, section, username, quarter, userType,
      sectionStudents
    } = props;
    if(section.length !== 1) return <Loader active inline='centered' />;

    const sectionDetail = _.find(section[0].details, {
      type: 'remark',
      quarter: parseInt(quarter)
    });

    const gender = _.groupBy(sectionStudents, o => o.student.gender)
    let currentDataMale = [], currentDataFemale = [];
    if(gender.hasOwnProperty('Male')) {
      currentDataMale = gender['Male'];
    }

    if(gender.hasOwnProperty('Female')) {
      currentDataFemale = gender['Female'];
    }

    const studentsTableMale = currentDataMale.map((sectionStudent, key )=> {
      const studentName = sectionStudent.student.lastName +', '+sectionStudent.student.firstName;
      return (
        <Table.Row key={key} className='sections-table-row' onClick={() => props.handleOpen(sectionStudent.sectionId, sectionStudent.sectionStudentId)}>
          <Table.Cell>{studentName}</Table.Cell>
        </Table.Row>
      );
    });

    const studentsTableFemale = currentDataFemale.map((sectionStudent, key )=> {
      const studentName = sectionStudent.student.lastName +', '+ sectionStudent.student.firstName;
        return (
          <Table.Row key={key} className='sections-table-row' onClick={() => props.handleOpen(sectionStudent.sectionId, sectionStudent.sectionStudentId)}>
            <Table.Cell>{studentName}</Table.Cell>
          </Table.Row>
        );
    });

    const headers = (
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell
            textAlign='center'
            sorted={column === 'name' ? direction : null}
            onClick={() => props.handleSort('name')}
          >
            Name
          </Table.HeaderCell>
        </Table.Row>
      </Table.Header>
    )
    const sortedCreated = _.orderBy(props.created, ['createdDate'], ['asc']);
    const createdTableBody = sortedCreated.map((create, key )=> {
      const section = _.find(props.sections, {
        sectionId: create.section.sectionId
      });

      return (
        <Table.Row key={key}>
          <Table.Cell>
            <NavLink  to={`/remarks/${create.section.sectionId}?quarter=${quarter}`}>
              {section.gradeLevel} - {section.name}
            </NavLink>
          </Table.Cell>
        </Table.Row>
      );
    });
    const sortedChecked = _.orderBy(props.checked, ['checkedDate'], ['asc']);
    const checkedTableBody = sortedChecked.map((check, key )=> {
      const section = _.find(props.sections, {
        sectionId: check.section.sectionId
      });

      return (
        <Table.Row key={key}>
          <Table.Cell>
            <NavLink  to={`/remarks/${check.section.sectionId}?quarter=${quarter}`}>
              {section.gradeLevel} - {section.name}
            </NavLink>
          </Table.Cell>
        </Table.Row>
      );
    });
    const sortedReviewed = _.orderBy(props.reviewed, ['createdDate'], ['asc']);
    const reviewedTableBody = sortedReviewed.map((review, key )=> {
      const section = _.find(props.sections, {
        sectionId: review.section.sectionId
      });

      return (
        <Table.Row key={key}>
          <Table.Cell>
            <NavLink  to={`/remarks/${review.section.sectionId}?quarter=${quarter}`}>
              {section.gradeLevel} - {section.name}
            </NavLink>
          </Table.Cell>
        </Table.Row>
      );
    });


    return (
      <div>
        <Segment>
          {
            sectionStudents.length === 0 ?
            <Segment placeholder>
              <Header icon>
                <Icon name='database' />
                Populate the {section[0].gradeLevel} - {section[0].name} with students.
              </Header>
              <Button primary>Section Page</Button>
            </Segment> :
            <Grid>
              <Grid.Row className="class-remark-title-row" columns={3}>
                <Grid.Column width={8}>
                  <span className="class-remark-title">
                    {section[0].gradeLevel} - {section[0].name}
                  </span>
                </Grid.Column>
                <Grid.Column width={3}>
                </Grid.Column>
                <Grid.Column width={5} textAlign='right'>

                {
                  sectionDetail.status === 'Approved' ?
                  <Label color='green' horizontal>
                    {sectionDetail.status}
                  </Label> :
                  <Label color='yellow' horizontal>
                    {sectionDetail.status}
                  </Label>
                }
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={8}>
                  <Menu compact>
                      {
                        userType === 'admin' ||  userType === 'levelHead'?
                        <Popup
                          on='click'
                          position='bottom center'
                          trigger={
                            <Menu.Item as='a'>
                              <Icon name='check' /> For Checking
                              <Label color={props.created.length === 0 ? 'green' : 'red'} floating>
                                {props.created.length}
                              </Label>
                            </Menu.Item>
                          }
                          className={props.created.length === 0 ? '' : 'popup-reminders'}
                        >
                        <Table basic='very' size='small'>
                          <Table.Body>
                            {createdTableBody}
                          </Table.Body>
                        </Table>
                        </Popup>: null
                      }
                      {
                        userType === 'admin' ||  userType === 'registrar'?
                        <Popup
                          on='click'
                          position='bottom center'
                          trigger={
                            <Menu.Item as='a'>
                              <Icon name='book' /> For Review
                              <Label color={props.checked.length === 0 ? 'green' : 'red'} floating>
                                {props.checked.length}
                              </Label>
                            </Menu.Item>
                          }
                          className={props.checked.length === 0 ? '' : 'popup-reminders'}
                        >
                        <Table basic='very' size='small'>
                          <Table.Body>
                            {checkedTableBody}
                          </Table.Body>
                        </Table>
                        </Popup>: null
                      }
                      {
                        userType === 'admin' ||  userType === 'principal'?
                        <Popup
                          on='click'
                          position='bottom center'
                          trigger={
                            <Menu.Item as='a'>
                              <Icon name='thumbs up' /> For Approval
                              <Label color={props.reviewed.length === 0 ? 'green' : 'red'} floating>
                                {props.reviewed.length}
                              </Label>
                            </Menu.Item>
                          }
                          className={props.reviewed.length === 0 ? '' : 'popup-reminders'}
                        >
                        <Table basic='very' size='small'>
                          <Table.Body>
                            {reviewedTableBody}
                          </Table.Body>
                        </Table>
                        </Popup>: null
                      }
                    </Menu>
                </Grid.Column>
                <Grid.Column width={8}>
                  <ClassRemarksApproval
                    username={username}
                    userType={userType}
                    sectionDetail={sectionDetail}
                    open={props.open}
                    handleApprovalOpen={props.handleApprovalOpen}
                    handleApprovalClose={props.handleApprovalClose}
                    handleUpdateSectionDetails={props.handleUpdateSectionDetails}
                  />
                </Grid.Column>
              </Grid.Row>
              {
                sectionDetail.status === 'Discarded' ?
                <Grid.Row>
                  <Grid.Column width={16}>
                    <Message
                      warning
                      header={`Your submission was discarded by ${sectionDetail.discardBy}`}
                      content={sectionDetail.discardNotes}
                    />
                  </Grid.Column>
                </Grid.Row> :
                null
              }
              <Grid.Row>
                <Grid.Column width={8}>
                  <h4>Male</h4>
                  <Table celled selectable sortable striped compact size='small'>
                    {headers}

                    <Table.Body>{studentsTableMale}</Table.Body>

                  </Table>
                </Grid.Column>

                <Grid.Column width={8}>
                  <h4>Female</h4>
                  <Table celled selectable sortable striped compact size='small'>
                    {headers}

                    <Table.Body>{studentsTableFemale}</Table.Body>

                  </Table>
                </Grid.Column>
              </Grid.Row>

            </Grid>
          }

        </Segment>

        <Modal
          open={props.modalOpen}
          onClose={props.handleClose}
          closeIcon
          size='small'
        >
          <Header content='Remarks' />
          <Modal.Content>
            <div>
              <Form>
                <strong>1st Quarter Remarks:</strong>
                <Form.Field>
                  <TextArea
                    name = "remarks1"
                    onChange = {props.handleInputChange}
                    value = {props.remarks1}
                    rows = {4}
                   />
                </Form.Field>

                <strong>2nd Quarter Remarks:</strong>
                <Form.Field>
                  <TextArea
                    name = "remarks2"
                    onChange = {props.handleInputChange}
                    value = {props.remarks2}
                    rows = {4}
                   />
                </Form.Field>

                <strong>3rd Quarter Remarks:</strong>
                <Form.Field>
                  <TextArea
                    name = "remarks3"
                    onChange = {props.handleInputChange}
                    value = {props.remarks3}
                    rows = {4}
                   />
                </Form.Field>

                <strong>4th Quarter Remarks:</strong>
                <Form.Field>
                  <TextArea
                    name = "remarks4"
                    onChange = {props.handleInputChange}
                    value = {props.remarks4}
                    rows = {4}
                   />
                </Form.Field>
              </Form>
            </div>
          </Modal.Content>
          <Modal.Actions>
            <Button color='red' onClick={props.handleClose} inverted>
              <Icon name='times' /> Cancel
            </Button>

            <Button color='green' onClick={() => {props.handleSubmit(props.section[0].sectionId, props.sectionStudentId)}} inverted>
              <Icon name='checkmark' /> Submit
            </Button>
          </Modal.Actions>
        </Modal>
      </div>
    )
  } else {
    return <Redirect to='/' />
  }

}

export default ClassRemarksPV;
